module.exports = __webpack_public_path__ + "static/media/backup.de06d4e5.svg";